// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"7623f6fb","1281":"7623f6fb","4555":"7623f6fb","5588":"7623f6fb","6840":"7623f6fb"}[chunkId] + ".chunk.css";
};